<script>

import TestAPI from '../componentes/TestAPI.svelte';
import APItmena from '../componentes/APItmena.svelte';
import RickMorty from '../componentes/RickMorty.svelte';
import Search from '../componentes/Search.svelte'
import GSheet from '../componentes/GSheet.svelte'

  let items = [
    { id: 1, name: "Milk", done: false },
    { id: 2, name: "Bread", done: true },
    { id: 3, name: "Eggs", done: false }
  ];
  let name = "";

  const addItem = () => {
    items = [
      ...items,
      {
        id: Math.random(),
        name,
        done: false
      }
    ];
    name = "";
  };

  const remove = item => {
    items = items.filter(i => i !== item);
  };

  const toggle = item => {
    item.done = !item.done;
    items = items;
  };
</script>

<style>
</style>


<div>

  header

  <h1>Grocery List =</h1>

  <form on:submit|preventDefault={addItem}>
    <label for="name">Add an item</label>
    <input id="name" type="text" bind:value={name} />
  </form>

  <ul>
    {#each items as item}
      <li class:done={item.done}>

        <input type="checkbox" bind:checked={item.done} />
        <span>{item.name}</span>
        <button class='button is-primary is-small' on:click={() => remove(item)}>&times;</button>
        <br><br>
      </li>
    {/each}
  </ul>
</div>

<hr>

<!-- <APItmena/> -->

Search: <Search/>

<h1>RickMorty API:</h1><br>
<hr>

<GSheet/>

<hr>
<!--  <TestAPI/> -->